
const state = {
    uid: '',
    account: '',
    accessToken: '',
    mobilePhone: '',
    roleName: '',
    roleIdentity: '',
    menuList:[],
    avatar: '~img/avatar-128-128.png'
}

const getters = {}

const mutations = {
    // setUid: (state, data) => {
    //     state.uid = data
    // },
    // setAccount: (state, data) => {
    //     state.account = data
    // },
    // setAccessToken: (state, data) => {
    //     state.accessToken = data
    // },
    // setRoleIdentity: (state, data) => {
    //     state.roleIdentity = data
    // }
}

const actions = {
    // login({ commit, data }) {
    //     if(data){
    //         commit('setUID', data.id)
    //         commit('setAccount', data.account)
    //         commit('setAccessToken', data.accessToken)
    //         commit('setRoleIdentity', data.roleIdentity)
    //     }
    // },
    // logout({commit}) {
    //         commit('setUID', '')
    //         commit('setName', '')
    //         commit('setToken', '')
    //         resolve()
    //     })
    // }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js